if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches && window.Lenis) {
  var hasGsap = !!window.gsap;
  var lenis = new window.Lenis({ autoRaf: !hasGsap, anchors: true });
  window.ckLenis = lenis;

  if (hasGsap) {
    window.gsap.ticker.add(function (time) {
      lenis.raf(time * 1000);
    });
    window.gsap.ticker.lagSmoothing(0);
  }
}
